export const itDict = {
  'Account recovery requires verified contact information':
    "Il ripristino dell'account richiede informazioni di contatto verificate",
  'An account with the given email already exists.':
    "Questa email è già utilizzata da un'altro account.",
  'Back to Sign In': 'Torna alla schermata di accesso',
  'Change Password': 'Cambia la password',
  Code: 'Codice',
  Confirm: 'Conferma',
  'Confirm a Code': 'Conferma un codice',
  'Confirm Password': 'Conferma la password',
  'Confirm Sign In': "Conferma l'accesso",
  'Confirm Sign Up': 'Conferma registrazione',
  'Confirmation Code': 'Codice di verifica',
  'Create a new account': 'Crea un nuovo account',
  'Create account': 'Crea account',
  'Create Account': 'Crea Account',
  Email: 'Email',
  'Enter your password': 'Inserisci la tua password',
  'Enter your username': 'Inserisci il tuo nome utente',
  'Forgot Password': 'Password dimenticata',
  'Forgot your password?': 'Password dimenticata?',
  'Have an account? ': 'Già registrato?',
  'Incorrect username or password': 'Nome utente o password errati',
  'Invalid password format': 'Formato della password non valido',
  'Invalid phone number format': 'Formato del numero di telefono non valido',
  'Lost your code?': 'Codice smarrito?',
  'New Password': 'Nuova password',
  or: 'o',
  'No account? ': 'Non hai un account?',
  Password: 'Password',
  'Password attempts exceeded':
    'Il numero massimo di tentativi di accesso falliti è stato raggiunto',
  'Phone Number': 'Numero di telefono',
  'Resend Code': 'Rispedisci codice',
  'Reset password': 'Reimposta password',
  'Reset your password': 'Reimposta la tua password',
  'Send Code': 'Invia codice',
  'Sign in': 'Accesso',
  'Sign In': 'Accesso',
  'Sign in to your account': 'Accedi al tuo account',
  'Sign Out': 'Esci',
  'Sign Up': 'Registrati',
  Skip: 'Salta',
  Submit: 'Invia',
  'User already exists': 'Utente già esistente',
  'User does not exist': 'Utente inesistente',
  Username: 'Nome utente',
  'Username cannot be empty': 'Il nome utente non può essere vuoto',
  Verify: 'Verifica',
  'Verify Contact': 'Verifica contatto',
};
